export default {"src":"/_next/static/media/houseAndPerson_40.82699b59.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};